import type { DropdownOption } from '../types/componentType';
import type { ProponentFormValues } from '../types/vida/cadastralMaintenance/proponentFormTypes';

export const PROPONENT_SEX_OPTIONS: DropdownOption[] = [
  { label: 'Feminino', value: '2' },
  { label: 'Masculino', value: '1' },
];

export const PROPONENT_ESTADO_CIVIL_OPTIONS: DropdownOption[] = [
  { label: 'Solteiro', value: '1' },
  { label: 'Viúvo', value: '2' },
  { label: 'Casado', value: '3' },
  { label: 'Desquitado', value: '4' },
  { label: 'Divorciado', value: '5' },
];

export const BRAZILIAN_UF_OPTIONS: DropdownOption[] = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];

export const EMPTY_PROPONENT_FORM_VALUES: ProponentFormValues = {
  nome: '',
  matricula: '',
  cpf: '',
  sexo: '',
  documento: '',
  estadoCivil: '',
  dataNascimento: '',
  cep: '',
  logradouro: '',
  numeroLogradouro: '',
  complemento: '',
  bairro: '',
  cidade: '',
  uf: '',
  cargo: '',
  capital: '',
  premio: '',
  salario: '',
};

const REQUIRED_FIELDS: Array<keyof ProponentFormValues> = [
  'nome',
  'matricula',
  'cpf',
  'sexo',
  'estadoCivil',
  'dataNascimento',
  'cep',
  'logradouro',
  'numeroLogradouro',
  'bairro',
  'cidade',
  'uf',
  'cargo',
  'capital',
  'salario',
];

export const getProponentFormValuesFromInitial = (
  initialValues?: ProponentFormValues,
): ProponentFormValues => ({
  ...EMPTY_PROPONENT_FORM_VALUES,
  ...(initialValues ?? {}),
});

export const isProponentFormValid = (values: ProponentFormValues): boolean =>
  REQUIRED_FIELDS.every((field) => values[field].trim() !== '');
